module.exports = __webpack_public_path__ + "assets/img/2.07103632.jpg";